import { BoxWithShadow } from 'components/blocks/BoxWithShadow';
import { BlockHeader } from 'components/blocks/BlockHeader';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { BlockContent } from 'components/blocks/BlockContent';
import { Routes } from 'routes';
import { NextLink } from 'components/blocks/NextLink';
import React, { useCallback, useMemo, useState } from 'react';
import { IResortPathInfo } from 'api/resort/types';
import styles from './styles.module.scss';

const incompleteResortsCount = 22;

export const AllResorts = ({
  regionResortListGuide,
}: {
  regionResortListGuide: Array<IResortPathInfo>,
}) => {
  const { t } = useOTSTranslation('common');
  const [showAll, setShowAll] = useState<boolean>(false);
  const shouldShowButton = !showAll && regionResortListGuide.length > incompleteResortsCount;

  const openFullDescription = useCallback(() => {
    setShowAll(true);
  }, []);

  return useMemo(() => {
    const subset = shouldShowButton ? regionResortListGuide.slice(0, incompleteResortsCount) : regionResortListGuide;

    const showBoxLink = (resort: IResortPathInfo) => (
      <React.Fragment key={resort.uuid}>
        <div>
          <NextLink href={Routes.resortTripPlanningOverview(resort)}>
            {resort.title}
          </NextLink>
        </div>
      </React.Fragment>
    );

    return (
      <div className={styles.allResorts}>
        <BoxWithShadow>
          <BlockHeader title={t('region.resortGuide.allResorts')} />
          <BlockContent className={styles.resortsList}>
            <div>
              {
                subset.slice(0, Math.floor(subset.length / 2)).map(showBoxLink)
              }
            </div>
            <div>
              {
                subset.slice(Math.floor(subset.length / 2)).map(showBoxLink)
              }
            </div>
          </BlockContent>
        </BoxWithShadow>
        {
          shouldShowButton && (
            <button
              type="button"
              className={styles.btnViewAllResorts}
              onClick={openFullDescription}
            >
              {t('region.resortGuide.viewAllResorts')}
            </button>
          )
        }
      </div>
    );
  }, [regionResortListGuide, shouldShowButton]);
};
